import { SizeMIcon } from './SizeMIcon';

/**
 * author: Austin Andrews
 * id D0FECA65-0432-4231-AFA5-EDD331188CD6
 * name size-m
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-m.svg
 * tags
 */
export const SizeMediumIcon = SizeMIcon;
export default SizeMediumIcon